import * as uamConnectionStatusTypes from '../../consts/uam/uamConnectionStatusTypes';

const isDeviceConnected = (status) => status === uamConnectionStatusTypes.CONNECTED;
const isDeviceDisconnected = (status) => status === uamConnectionStatusTypes.DISCONNECTED;
const isDeviceConnecting = (status) => status === uamConnectionStatusTypes.CONNECTING;

export default {
    isDeviceConnected,
    isDeviceDisconnected,
    isDeviceConnecting,
};
